import { Menu } from "lucide-react";
import { api } from "../../lib/api-client";
import { sanitizeHeaderText } from "../../lib/sanitize";

interface TopBarProps {
  userEmail?: string;
  // onMenuClick solo se pasa en mobile (ver MailLayout) — abre el drawer de
  // carpetas, que en desktop ya está siempre visible como columna fija.
  onMenuClick?: () => void;
}

export default function TopBar({ userEmail, onMenuClick }: TopBarProps) {
  const initials = sanitizeHeaderText(userEmail)?.slice(0, 2).toUpperCase() || "?";

  async function handleLogout() {
    const { logoutUrl } = await api.logout();
    // Si el IdP soporta RP-Initiated Logout, hay que navegar ahí de verdad
    // para cerrar también SU sesión de navegador — de lo contrario, la
    // próxima vez que se dispare /auth/login el IdP todavía te reconoce
    // logueado y te vuelve a meter sin pedir nada (el botón "Salir" se
    // sentiría roto). Si no hay logoutUrl, "/" alcanza igual (recarga
    // completa, no navigate de react-router, para que App.tsx pida /auth/me
    // desde cero con estado realmente limpio, no en memoria stale).
    window.location.href = logoutUrl ?? "/";
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 8,
        height: 48,
        flexShrink: 0,
        padding: "0 16px",
        borderBottom: "0.5px solid var(--color-900)",
        // Un paso más fuerte de la escala clara — con --surface-1 (casi
        // blanco) el header se perdía contra el fondo de la página, sin
        // ninguna separación visible.
        background: "var(--color-700)",
      }}
    >
      {onMenuClick && (
        <button
          onClick={onMenuClick}
          title="Carpetas"
          style={{
            display: "flex",
            border: "none",
            background: "transparent",
            color: "var(--text-secondary)",
            cursor: "pointer",
            padding: 4,
            // El resto de la barra sigue alineado a la derecha
            // (justifyContent: flex-end) — auto lo empuja a la izquierda.
            marginRight: "auto",
          }}
        >
          <Menu size={20} />
        </button>
      )}
      <div
        style={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          background: "var(--color-selected-bg)",
          color: "var(--color-selected-fg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          fontWeight: 500,
          flexShrink: 0,
        }}
      >
        {initials}
      </div>
      <span
        style={{
          fontSize: 12,
          color: "var(--text-secondary)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: onMenuClick ? 130 : 220,
        }}
      >
        {sanitizeHeaderText(userEmail)}
      </span>
      <button
        onClick={handleLogout}
        title="Cerrar sesión"
        style={{
          border: "none",
          background: "transparent",
          color: "var(--text-muted)",
          cursor: "pointer",
          fontSize: 12,
          padding: 4,
        }}
      >
        Salir
      </button>
    </div>
  );
}
